import {
  FieldErrors,
  hasFieldError,
} from "@/shared/lib/errors/validation-error";
import { Label } from "@/shared/components/ui/label";
import { DatePicker } from "@/shared/components/date-picker";
import { InputErrorMessages } from "@/shared/components/errors/input-error-messages";

type DateInputProps = {
  label?: string;
  date: string | null;
  onDateChange: (date: string | null) => void;
  disabled: boolean;
  allowYearSelection?: boolean;
  fieldErrors?: string[];
  resetFieldError?: () => void;
};

export function DateInput({
  label,
  date,
  onDateChange,
  disabled,
  allowYearSelection = false,
  fieldErrors,
  resetFieldError,
}: DateInputProps) {
  const formattedDate = date ? new Date(date) : undefined;
  const onFormattedDateChange = (d: Date | undefined) => {
    if (!d) {
      onDateChange(null);
      return;
    }

    // We want to add the current time to the date
    const dateTime = new Date();
    dateTime.setUTCFullYear(d.getUTCFullYear(), d.getMonth(), d.getDate());
    resetFieldError?.();
    onDateChange(dateTime.toISOString());
  };

  const markError = hasFieldError(
    { message: "", errors: { date: fieldErrors ?? [] } } as unknown as {
      message: string;
      errors: FieldErrors;
    },
    "date",
  );

  return (
    <div className="grid content-start gap-1.5">
      {label && <Label className="min-h-5">{label}</Label>}
      <DatePicker
        date={formattedDate}
        onDateChange={onFormattedDateChange}
        markError={markError && (fieldErrors?.length ?? 0) > 0}
        disabled={disabled}
        allowYearSelection={allowYearSelection}
      />
      <div className="min-h-5">
        <InputErrorMessages errors={fieldErrors ?? []} />
      </div>
    </div>
  );
}
